import { useState } from 'react'
import { getImageUrl } from '@/utils/image'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints } from '@/styles'
import PhotoSlider from '@/components/photo-slider'
import { PhotoGrid } from '@/components/photo-grid'
import ImageLightbox from '@/components/image-lightbox'

const getLightboxPhotos = images => {
  const photoConfig = {
    fit: 'fit-in/1150x785',
    quality: 100
  }
  const photos = images.map(({ aws_s3_key }) => {
    return {
      src: getImageUrl(aws_s3_key, photoConfig)
    }
  })
  return photos
}

const ListingPhotos = ({ images, sliderSettings, altText, buttonText }) => {
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const showCarousel = displayMobile
  const largeImages = getLightboxPhotos(images)
  const rawImages = images.map(({ aws_s3_key }) => aws_s3_key)
  const [lightboxIndex, setLightboxIndex] = useState(-1)

  return (
    <div className={showCarousel ? 'photo-carousel' : 'photo-grid'}>
      {showCarousel ? (
        <PhotoSlider
          images={rawImages}
          largeImages={largeImages}
          {...sliderSettings}
          altText={altText}
          buttonText={buttonText}
          openImage={setLightboxIndex}
        />
      ) : (
        <PhotoGrid images={rawImages} openImage={setLightboxIndex} />
      )}
      <ImageLightbox
        index={lightboxIndex}
        open={lightboxIndex >= 0}
        close={() => setLightboxIndex(-1)}
        slides={largeImages}
      />
    </div>
  )
}

export default ListingPhotos
